import { __assign, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemsGrid, MenuModalStyle, ModalHeader, NothingFoundSpan, SearchDiv, } from "../styles";
import { MenuSubitem } from "../MenuSubitem";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Input } from "../../Input";
import { MenuSearchItem } from "../MenuSearchItem";
import { IconChevronLeft } from "../../icons";
export var formatSearchItems = function (menuItems, parentPath, parentTexts) {
    if (parentPath === void 0) { parentPath = ""; }
    if (parentTexts === void 0) { parentTexts = []; }
    return menuItems
        .filter(function (item) {
        return !item.filler && item.condition !== false && !item.id.includes("search");
    })
        .flatMap(function (item) {
        var currentPath = parentPath + (item.path || "");
        var currentTexts = __spreadArray(__spreadArray([], parentTexts, true), [item.text], false);
        if (item.subitems && item.subitems.length > 0) {
            // Chamada recursiva para os subitems
            return formatSearchItems(item.subitems, currentPath, currentTexts);
        }
        // Item válido sem subitems
        return [
            __assign(__assign({}, item), { path: currentPath, searchText: currentTexts.join("/") }),
        ];
    });
};
var formatMenuItems = function (item) {
    var _a;
    var flattenedSubitems = (_a = item.subitems) === null || _a === void 0 ? void 0 : _a.filter(function (subitem) { return !subitem.filler && subitem.condition !== false; }).flatMap(function (subitem) {
        var parentPath = item.path || "";
        var currentPath = parentPath + (subitem.path || "");
        // Caso o subitem não tenha subitens, apenas atualize seu caminho.
        if (!subitem.subitems) {
            return __assign(__assign({}, subitem), { path: currentPath });
        }
        // Caso tenha subitens, atualize o caminho do subitem pai e dos subsubitens.
        var filteredSubsubitems = subitem.subitems.filter(function (subsubitem) { return !subsubitem.filler && subsubitem.condition !== false; });
        var formattedSubsubitems = filteredSubsubitems.map(function (subsubitem) {
            return __assign(__assign({}, subsubitem), { path: currentPath + (subsubitem.path || ""), isSubsubitem: true, isLastSubsubitem: subsubitem.id === filteredSubsubitems.slice(-1)[0].id });
        });
        return __spreadArray([
            __assign(__assign({}, subitem), { path: 
                // Caso o subitem tenha subitens, o caminho do subitem pai é o caminho do primeiro subsubitem.
                currentPath + (subitem.subitems ? subitem.subitems[0].path : "") })
        ], formattedSubsubitems, true);
    });
    return __assign(__assign({}, item), { subitems: flattenedSubitems });
};
var filterItems = function (item, search) {
    var _a;
    return (_a = item.searchText) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase());
};
export var MenuModal = function (_a) {
    var _b, _c;
    var item = _a.item, setModalItem = _a.setModalItem, menuItems = _a.menuItems;
    var _d = useState(""), search = _d[0], setSearch = _d[1];
    var searchItemsFormatted = formatSearchItems(menuItems);
    var searchItemsFiltered = searchItemsFormatted.filter(function (item) {
        return filterItems(item, search);
    });
    var itemFormatted = formatMenuItems(item);
    var elementById = (_b = document
        .getElementById("menu-item-".concat(item.id))) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var maxHeight = windowHeight - ((elementById === null || elementById === void 0 ? void 0 : elementById.top) || 0) - 16;
    var eventListenerFunction = function () {
        setModalItem(null);
    };
    useEffect(function () {
        window.addEventListener("click", eventListenerFunction);
        return function () {
            window.removeEventListener("click", eventListenerFunction);
        };
    }, []);
    return createPortal(_jsxs(MenuModalStyle, { onClick: function (e) { return e.stopPropagation(); }, top: elementById === null || elementById === void 0 ? void 0 : elementById.top, left: elementById === null || elementById === void 0 ? void 0 : elementById.right, maxHeight: maxHeight, children: [_jsxs(ModalHeader, { onClick: function () { return setModalItem(null); }, children: [_jsx(IconChevronLeft, {}), item.text] }), item.id.includes("search") ? (_jsxs(_Fragment, { children: [_jsx(SearchDiv, { children: _jsx(Input, { autoFocus: true, label: "Buscar", value: search, onChange: function (e) { return setSearch(e.target.value); } }) }), search.length > 0 &&
                        (searchItemsFiltered.length > 0 ? (searchItemsFiltered.map(function (item) { return (_jsx(MenuSearchItem, { subsubitem: item, parentPath: "", setModalItem: setModalItem }, item.id)); })) : (_jsx(NothingFoundSpan, { children: "Nada encontrado" })))] })) : (_jsx(ItemsGrid, { children: (_c = itemFormatted.subitems) === null || _c === void 0 ? void 0 : _c.map(function (subitem) {
                    return (_jsx(MenuSubitem, { subitem: subitem, setModalItem: setModalItem }, subitem.id));
                }) }))] }), document.body);
};
//# sourceMappingURL=index.js.map